module.exports = __webpack_public_path__ + "img/non-returnable-thin.41c6ff8.svg";